const STORAGE_KEY = 'lastSelectedCountryID';

let lastSelectedCountryID: string | null = null;

const readFromStorage = (): string | null => {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
};

const writeToStorage = (countryID: string | null) => {
    try {
        if (countryID) {
            sessionStorage.setItem(STORAGE_KEY, countryID);
        } else {
            sessionStorage.removeItem(STORAGE_KEY);
        }
    } catch {
        // Ignore storage errors (e.g. private browsing restrictions).
    }
};

lastSelectedCountryID = readFromStorage();

export const getLastSelectedCountryID = (): string | null => lastSelectedCountryID;

export const setLastSelectedCountryID = (countryID: string | null | undefined) => {    
    if (!countryID) {
        lastSelectedCountryID = null;
        writeToStorage(null);
        return;
    }

    lastSelectedCountryID = countryID;
    writeToStorage(countryID);
};

export const resolveCountryIDFromUser = (user?: {
    lastSelectedCountryID?: string;   
} | null): string | null => user?.lastSelectedCountryID ?? null;

export const syncLastSelectedCountryFromUser = (user?: {
    lastSelectedCountryID?: string;
} | null) => {
    setLastSelectedCountryID(resolveCountryIDFromUser(user));
};

export const clearLastSelectedCountryID = () => setLastSelectedCountryID(null);
